<template>
  <div style="overflow:auto;" class="wrapepr">
    <!--商机!-->
    <div class="h mb8" v-if="businessInfoList.length>0">商机</div>
    <!--<hr v-if="businessInfoList.length>0"/>-->
    <!--<a @click="showAllBusiness = !showAllBusiness" class="show-more" style="float:right" v-if="businessInfoList.length>5">{{businessShowWord}}</a>-->
    <div class="flex mb8" v-for="(item,index) in businessInfoList" v-if="index<=4||showAllBusiness" style="align-items: flex-end;line-height: 1.8;padding-top: 10px">
      <div class="flexauto">{{item.msg}}</div>
      <div class="flexnone ml28">{{item.showTimeStr}}</div>
    </div>
    <a @click="showAllBusiness = !showAllBusiness" class="show-more" style="float:right" v-if="businessInfoList.length>5">{{businessShowWord}}</a>


    <!--合同!-->
    <div class="h mb8" v-if="contractInfoList.length>0">合同</div>
    <!--<hr v-if="contractInfoList.length>0"/>-->
    <div class="flex mb8" v-for="(item,index) in contractInfoList" v-if="index<=4||showAllContract" style="align-items: flex-end;line-height: 1.8;padding-top: 10px">
      <div class="flexauto">{{item.showMsg}}</div>
      <div class="flexnone"  v-if="item.subjectType==3 && item.showType==1 && item.payState==0" v-p="{api:'bill/getEpsBillDetail'}"><a @click="toPay(item)">去支付</a></div>
      <div class="flexnone"  v-if="item.subjectType==1 && item.showType==1 && item.deliveryState==0" v-p="{api:'sign/delivery/save'}"><a @click="toDelivery(item)">去交割</a></div>
      <div class="flexnone ml28">{{item.showTimeStr}}</div>
    </div>
    <a @click="showAllContract = !showAllContract" class="show-more" style="float:right" v-if="contractInfoList.length>5">{{contractShowWord}}</a>
    <!--审核!-->
    <div class="h" v-if="auditInfoList.length>0">审核</div>
    <!--<hr v-if="auditInfoList.length>0"/>-->
    <div class="flex mb8" v-for="(item,index) in auditInfoList" v-if="index<=4||showAllAudit" style="align-items: flex-end;line-height: 1.8;padding-top: 10px">
      <div class="flexauto">{{item.showMsg}}</div>
      <div class="flexnone"  v-if="item.subjectType==1 && item.showType==3" v-p="{api:'certificate/updatePaymentVoucher'}"><a @click="toEditCertificate(item)">修改</a></div>
      <div class="flexnone ml28" >{{item.showTimeStr}}</div>
    </div>
    <a @click="showAllAudit = !showAllAudit" class="show-more" style="float:right" v-if="auditInfoList.length>5">{{auditShowWord}}</a>
    <delivery-input-person :n="deliveryInputPersonN" :contractId="contractId"
                           :stockFid="stockFid" :projectName="projectName"
                           :stockNumber="stockNumber"
                           @done="initData"
    ></delivery-input-person>
    <div align="center" v-if="contractInfoList.length<=0 && auditInfoList.length<=0 && businessInfoList.length<=0 &&isShow">
      <img src="@/assets/relaxtaskreminder.png"  width="58px" height="70px" style="margin-top:30px">
      <div style="color: #D0D0D0;font-size: 12px">休息一下，暂时无任务需要处理</div>
    </div>

  </div>
</template>
<script>
  import { getTaskReminderMsg} from 'api/workBench'
  import {formatDateTime} from "@/utils/format.js"
  import DeliveryInputPerson from '../../contract/contractList/components/DeliveryInputPerson'
  export default {
    name: "TaskReminder",
    props: {
      projectFid: {
        type: String,
        default: ''
      }
    },
    filters:{
        formatDate(time) {
          let date = new Date(time)
          return formatDateTime(date,'hhhh-MM-dd HH:mm')
        }
    },
    watch:{
      projectFid(){
        this.initData()
      },
      $route(to, from) {
        if(from.name==='firstcollection'){
          this.initData()
        }
      }
    },
    components: {
      DeliveryInputPerson
    },
    computed:{
      businessShowWord:function(){
        if(this.showAllBusiness == false){　　　　　　　　　　　
          return '展开'
        }else{
          return '收起'
        }
      },
      contractShowWord:function(){
        if(this.showAllContract == false){　　　　　　　　　　　
          return '展开'
        }else{
          return '收起'
        }
      },
      auditShowWord:function(){
        if(this.showAllAudit == false){　　　　　　　　　　　
          return '展开'
        }else{
          return '收起'
        }
      }

    },
    methods: {
      initData() {
        if(!this.projectFid){
          return
        }
        getTaskReminderMsg(this.projectFid).then( res => {
          this.businessInfoList = res.data.buseinssInfo
          this.contractInfoList = res.data.contractInfo
          this.auditInfoList = res.data.auditInfos
          if(this.businessInfoList.length<=0 && this.contractInfoList.length<=0 &&  this.auditInfoList.length<=0 ) {
              this.isShow = true;
          }
        })
      },
      toDelivery(item) {
          this.contractId = item.contractFid
          this.stockFid = item.stockFid
          this.projectName = item.projectName
          this.stockNumber = item.stockNumber
          this.deliveryInputPersonN++
      },
      toPay(item) {
        this.$router.push({
          name: 'firstcollection',
          query: {isFirst: 1, pCode: item.contractCode, uid: item.customerUid}
        })
      },
      toEditCertificate(item) {
        this.$router.push({
          name: 'certificateedit',
          query: {bNum: item.fid, cCode: item.contractCode, proId: this.projectFid}
        })
      }
    },
    data() {
      return {
        businessInfoList:[],
        contractInfoList:[],
        auditInfoList:[],
        showAllBusiness:false,
        showAllContract:false,
        showAllAudit:false,
        contractId:'',
        stockFid:'',
        projectName:'',
        stockNumber:'',
        deliveryInputPersonN:0,
        isShow:false
      }
    },
  created() {
    this.initData()
  }
  }
</script>
<style scoped>
  .h{
    line-height: 45px;

    border-bottom: 1px solid #DFDFDF;;
  }
  .wrapepr{
    min-height: 188px;
    max-height: 571px;

  }

</style>

